<template>
    <tr :style="{'cursor': 'pointer'}" @click="handleItemClick">
        <td>{{ item.name }}</td>
        <td>{{ item.position | NoEmpty }}</td>
        <td>{{ item.phone | NoEmpty }}</td>
        <td>{{ item.email | NoEmpty }}</td>
        <td>{{ item.comment | NoEmpty }}</td>
    </tr>
</template>

<script>
    import NoEmpty from '../../Filters/NoEmpty'
    import _ from 'lodash'

    export default {
        name: "ClientSpecialistItem",
        props: {
            item: {
                type: Object
            }
        },
        filters: {
            NoEmpty
        },
        data() {
            return {}
        },
        methods: {
            handleItemClick() {
                this.$emit('click', this.item)
            }
        }
    }
</script>

<style scoped>

</style>